<template>
    <v-card>
        <v-card-title class="headline">{{title}}</v-card-title>
        <v-card-text>
            <v-container fluid>
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="description" label="Nazwa kategorii"></v-text-field>
                    </v-col>
                </v-row>

            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="save()" color="success">Zapisz</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="closeForm()" color="error">Zamknij</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import swal from "sweetalert";
    import {descriptionService} from "../../services";

    export default {
        name: "CategoryEdit",
        props: ["editedObject"],
        data() {
            return {
                description: null,
                title: 'Dodawanie kategorii'
            }
        },
        methods: {
            save() {
                if(!this.description)
                {
                    this.showError(false,'Nie podano nazwy kategorii.')
                    return
                }
                if(this.editedObject)
                {
                    descriptionService.updateCategory({id: this.editedObject.id, description: this.description}).then(() => {
                        this.closeForm()
                    }).catch(() => {
                        this.showError(false,"Błąd zapisu kategorii.")
                    })
                }
                else
                {
                    descriptionService.addCategory({description: this.description}).then(()=> {
                        this.closeForm()
                    }).catch(()=>{
                        this.showError(false,"Błąd zapisu kategorii.")
                    })
                }
            },
            closeForm() {
                this.$emit('close')
            },
            showError(close, text) {
                swal({
                    title: "Błąd",
                    text: text,
                    icon: "warning",
                    button: "OK"
                }).then(() => {
                    this.loading = false;
                    if (close) {
                        this.$emit("close");
                    }
                });
            },
        },
        watch: {
            editedObject: {
                immediate: true,
                handler(val) {
                    if(val != null)
                    {
                        this.title = 'Edycja kategorii'
                        this.description = val.description
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>